import React from 'react';
import Switch from "react-switch"
import { Spinner } from "react-bootstrap";
import { shallowEqual } from 'react-redux';

import { TranslationType } from '../Types/MiscTypes';
import { useAppSelector } from '../redux/store';

interface RejectToggleProps {
  rejected: boolean | number;
  isLoading?: boolean;
  statsText: TranslationType;
  handleChange: (effort: any) => void;
  disabled?: boolean;
}

export const RejectToggle: React.FC<RejectToggleProps> = ({ rejected, handleChange, isLoading, statsText, disabled }) => {
  const authenticatedProvider = useAppSelector(state => state.provider, shallowEqual);
  const isReadOnly = authenticatedProvider.viewingAs.readOnly;

  return (
    <Switch
      id="icon-switch"
      onChange={isReadOnly ? () => { } : handleChange}
      checked={!rejected}
      offColor="#DC3545"
      onColor="#4F89E1"
      className="react-switch"
      width={100}
      uncheckedIcon={
        <div className='d-flex justify-content-center align-items-center h-100 text-white small pr-4'>
          {!isLoading ? statsText.rejected || 'Rejected' : <Spinner animation="border" variant="light" size="sm" />}
        </div>
      }
      checkedIcon={
        <div className='d-flex justify-content-center align-items-center h-100 text-white small pl-4'>
          {!isLoading ? statsText.accepted || 'Accepted' : <Spinner animation="border" variant="light" size="sm" />}
        </div>
      }
      disabled={isReadOnly || disabled}
    />
  );
};